import { Box, Divider, Typography } from '@mui/material';
import React from 'react';
import zeplinColor from 'theme/Color';
import BasicPreview from './BasicPreview';
import TopCitiesChart from './TopCitiesChart';
import CategoryList from './CategoriesList';

const Profile = ({
  setTabValue,
  value,
}: {
  setTabValue: React.Dispatch<React.SetStateAction<number>>;
  value: any;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: { xs: '16px', md: '24px' },
        flexDirection: { xs: 'column', md: 'row' },
      }}
    >
      <Box
        sx={{
          flex: 1,
          height: 'calc(100vh - 320px)',
          overflowY: 'scroll',
          border: `1px solid ${zeplinColor.Neutral5}`,
          borderRadius: '16px',
          padding: '16px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Typography variant='responsiveHeading3'>Profile</Typography>
          <Typography variant='responsiveBody2' color={zeplinColor.Neutral8}>
            @wcalzoni's followers are in their early thirties with above average income.The account
            has a notable audience concentration in Kansas City.
          </Typography>
        </Box>
        <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <img src='/assets/academically.svg' alt='profile' width='22px' height='22px' />
              <Typography variant='responsiveHeading3'>Academically</Typography>
            </Box>
            <Typography
              variant='responsiveButtonMedium'
              color={zeplinColor.Brand1}
              sx={{ cursor: 'pointer' }}
              onClick={() => setTabValue(3)}
            >
              Analysis
            </Typography>
          </Box>
          <Typography variant='responsiveBody2' color={zeplinColor.Neutral8}>
            The number of @wcalzonis followers that have completed higher education is about average
            for Instagram. The universities University of Kansas, Kansas State University, Missouri
            State University and University of Central Missouri are among those standing out
            significantly above the norm in terms of attendence by this audience.
          </Typography>
        </Box>
        <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <img src='/assets/professionally.svg' alt='profile' width='22px' height='22px' />
              <Typography variant='responsiveHeading3'>Professionally</Typography>
            </Box>
            <Typography
              variant='responsiveButtonMedium'
              color={zeplinColor.Brand1}
              sx={{ cursor: 'pointer' }}
              onClick={() => setTabValue(4)}
            >
              Analysis
            </Typography>
          </Box>
          <Typography variant='responsiveBody2' color={zeplinColor.Neutral8}>
            The number of @wcalzonis followers that have completed higher education is about average
            for Instagram. The universities University of Kansas, Kansas State University, Missouri
            State University and University of Central Missouri are among those standing out
            significantly above the norm in terms of attendence by this audience.
          </Typography>
        </Box>
        <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <img src='/assets/spare-time.svg' alt='profile' width='22px' height='22px' />
              <Typography variant='responsiveHeading3'>In their spare time</Typography>
            </Box>
            <Typography
              variant='responsiveButtonMedium'
              color={zeplinColor.Brand1}
              sx={{ cursor: 'pointer' }}
              onClick={() => setTabValue(5)}
            >
              Analysis
            </Typography>
          </Box>
          <Typography variant='responsiveBody2' color={zeplinColor.Neutral8}>
            The number of @wcalzonis followers that have completed higher education is about average
            for Instagram. The universities University of Kansas, Kansas State University, Missouri
            State University and University of Central Missouri are among those standing out
            significantly above the norm in terms of attendence by this audience.
          </Typography>
        </Box>
        <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <img src='/assets/music-taste.svg' alt='profile' width='22px' height='22px' />
              <Typography variant='responsiveHeading3'>Music taste</Typography>
            </Box>
            <Typography
              variant='responsiveButtonMedium'
              color={zeplinColor.Brand1}
              sx={{ cursor: 'pointer' }}
              onClick={() => setTabValue(7)}
            >
              Analysis
            </Typography>
          </Box>
          <Typography variant='responsiveBody2' color={zeplinColor.Neutral8}>
            The number of @wcalzonis followers that have completed higher education is about average
            for Instagram. The universities University of Kansas, Kansas State University, Missouri
            State University and University of Central Missouri are among those standing out
            significantly above the norm in terms of attendence by this audience.
          </Typography>
        </Box>
        <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <img src='/assets/music-taste.svg' alt='profile' width='22px' height='22px' />
              <Typography variant='responsiveHeading3'>Sports followed</Typography>
            </Box>
            <Typography
              variant='responsiveButtonMedium'
              color={zeplinColor.Brand1}
              sx={{ cursor: 'pointer' }}
              onClick={() => setTabValue(9)}
            >
              Analysis
            </Typography>
          </Box>
          <Typography variant='responsiveBody2' color={zeplinColor.Neutral8}>
            The number of @wcalzonis followers that have completed higher education is about average
            for Instagram. The universities University of Kansas, Kansas State University, Missouri
            State University and University of Central Missouri are among those standing out
            significantly above the norm in terms of attendence by this audience.
          </Typography>
        </Box>
        <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <img src='/assets/music-taste.svg' alt='profile' width='22px' height='22px' />
              <Typography variant='responsiveHeading3'>Influencer and celebrities</Typography>
            </Box>
            <Typography
              variant='responsiveButtonMedium'
              color={zeplinColor.Brand1}
              sx={{ cursor: 'pointer' }}
              onClick={() => setTabValue(6)}
            >
              Analysis
            </Typography>
          </Box>
          <Typography variant='responsiveBody2' color={zeplinColor.Neutral8}>
            The number of @wcalzonis followers that have completed higher education is about average
            for Instagram. The universities University of Kansas, Kansas State University, Missouri
            State University and University of Central Missouri are among those standing out
            significantly above the norm in terms of attendence by this audience.
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          flex: 3,
          display: 'flex',
          flexDirection: 'column',
          gap: '24px',
          height: 'calc(100vh - 320px)',
          overflowY: 'scroll',
        }}
      >
        <BasicPreview setTabValue={setTabValue} value={value?.basics} />
        <TopCitiesChart
          cities={value?.location?.topCities}
          setTabValue={setTabValue}
          value={value?.location?.topCities}
        />
        <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
          {' '}
          <CategoryList
            title='Top Brands'
            items={value?.brands}
            onViewAll={() => setTabValue(10)}
          />
          <CategoryList
            title='Media'
            items={value?.media}
            onViewAll={() => setTabValue(11)}
            maxHeight='300px'
          />
        </Box>
        <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
          {' '}
          <CategoryList
            title='Music'
            items={value?.music?.soloArtists}
            onViewAll={() => setTabValue(7)}
          />
          <CategoryList
            title='Sport'
            items={value?.sports?.teams}
            onViewAll={() => setTabValue(9)}
            maxHeight='300px'
          />
        </Box>
        <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
          {' '}
          <CategoryList
            title='Celebrities'
            items={value?.brands}
            onViewAll={() => console.log('View all universities')}
          />
          <CategoryList
            title='Influencer'
            items={value?.influencers}
            onViewAll={() => setTabValue(6)}
            maxHeight='300px'
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Profile;
